import { render, staticRenderFns } from "./NoveltyCampaignSummarySection.vue?vue&type=template&id=a7022e9a&scoped=true&"
import script from "./NoveltyCampaignSummarySection.vue?vue&type=script&lang=ts&"
export * from "./NoveltyCampaignSummarySection.vue?vue&type=script&lang=ts&"
import style0 from "./NoveltyCampaignSummarySection.vue?vue&type=style&index=0&id=a7022e9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7022e9a",
  null
  
)

export default component.exports